import React from 'react';

const Notfound = () =>
{return(
<div>
    <h1> Not Found</h1>
    <p className='lead'>
    Invalid: Page does not exist...
    </p>
</div>
);
}

export default Notfound;